import React from 'react';
import PropTypes from 'prop-types';
import HashHero from 'hash-heroes';
import cn from 'classnames';

import './Tile.css';

export default class Tile extends React.Component {
    state = {
        isHovered: null,
    };

    onClick = () => {
        const {
            checkFunction,
            isClaimed,
            isDisabled,
            shouldShowNotification,
            showNotification,
            xCoord,
            yCoord
        } = this.props;

        if (isDisabled || isClaimed) {
            return;
        }

        if (shouldShowNotification) {
            // user does not have an address, show metamask notification
            showNotification();
            return;
        }

        if (checkFunction && xCoord !== null && yCoord !== null) {
            checkFunction(xCoord, yCoord);
        }
    }

    onMouseEnter = () => {
        this.setState({
            isHovered: true,
        });
    }

    onMouseLeave = () => {
        this.setState({
            isHovered: false,
        });
    }

    render() {
        const {
            address,
            isClaimed,
            isClaimedByCurrentAddress,
            isDisabled,
            isLoading,
            key,
            showHero,
            isWinner,
        } = this.props;
        const { isHovered } = this.state;
        const classNames = cn('tile', {
            'is-claimed-by-current-user': isClaimedByCurrentAddress,
            'is-winner': isWinner,
            'is-loading': isLoading,
            'highlight-able': !isClaimed && !isLoading && !isDisabled,
        });
        const showHoverMessage = isHovered && !isLoading && !showHero && !isDisabled;

        return (
            <div
                key={key}
                className={classNames}
                onClick={this.onClick}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                {showHoverMessage && (
                    <div className="tile-message">
                        <p>Click</p>
                        <p>To</p>
                        <p>Claim</p>
                    </div>
                )}
                {showHero && <HashHero
                    seed={address}
                    scalingFactor={4}
                />}
            </div>
        )
    }
}

Tile.defaultValues = {
    checkFunction: () => {},
    showNotification: () => {},
};

Tile.propTypes = {
    address: PropTypes.string,
    checkFunction: PropTypes.func,
    isClaimed: PropTypes.bool.isRequired,
    isClaimedByCurrentAddress: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    key: PropTypes.string.isRequired,
    showHero: PropTypes.bool.isRequired,
    showNotification: PropTypes.func,
    xCoord: PropTypes.number.isRequired,
    yCoord: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Tile.js